import { render, staticRenderFns } from "./UserTaskReportPage.vue?vue&type=template&id=5a825b17"
import script from "./UserTaskReportPage.vue?vue&type=script&lang=js"
export * from "./UserTaskReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports